import React, { PropTypes } from 'react';
import FormatIndicator from '@bibliocommons/format-indicator';
import PublicationDate from '@bibliocommons/shared-publication-date';
import CompactTitle from '../CompactTitle';

import './CompactItemInfo.scss';

export default function CompactItemInfo({ title, subtitle, author, format, publicationDate, id }) {
  return (
    <div className="cp-compact-item-info">
      {(title || subtitle) &&
        <CompactTitle
          title={title}
          subtitle={subtitle}
          renderAsLink={(typeof id === 'string')}
          id={id} />
      }
      {author &&
        <div className="author">{author}</div>
      }
      {format &&
        <FormatIndicator format={format} />
      }
      {publicationDate &&
        <PublicationDate publicationDate={publicationDate} />
      }
    </div>
  );
}

CompactItemInfo.defaultProps = {
  id: false
};

// Note: Can't pass bib may or may not be derived from a bib
CompactItemInfo.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  author: PropTypes.string,
  format: PropTypes.string,
  publicationDate: PropTypes.string,
  id: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/components/shared/CompactItemInfo/CompactItemInfo.jsx